// extracted by mini-css-extract-plugin
export var completionBody = "_co-2";
export var completionCard = "_co-0";
export var completionFooter = "_co-3";
export var completionTitle = "_co-1";